import { createSlice } from '@reduxjs/toolkit';
import { isNil } from 'ramda';
import {
  CleanupImageProcessingAction,
  ImageProcessingState,
  ImagesState,
  ProcessImageAction,
  ProcessImageRejectAction,
  ProcessImageResolveAction,
} from './types';

const name = 'images';

const initialState: ImagesState = {
  processing: {},
};

const getInitialImageUploadState = (): ImageProcessingState => ({});

export const { reducer, actions } = createSlice({
  name,
  initialState,
  reducers: {
    processImage: (state, action: ProcessImageAction) => {
      const {
        payload: { id, filename, filetype },
      } = action;
      state.processing[id] = getInitialImageUploadState();
      state.processing[id].status = 'processing';
      state.processing[id].filename = filename;
      state.processing[id].filetype = filetype;
    },
    processImageResolve: (state, action: ProcessImageResolveAction) => {
      const {
        payload: { id },
      } = action;
      if (isNil(state.processing[id])) return; // If state has been removed for this id we are no longer tracking it
      state.processing[id].status = 'resolved';
      state.processing[id].processedDataUrl = action.payload.processedDataUrl;
      state.processing[id].resizing = action.payload.resizing;
    },
    processImageReject: (state, action: ProcessImageRejectAction) => {
      const {
        payload: { id, error },
      } = action;
      if (isNil(state.processing[id])) return; // If state has been removed for this id we are no longer tracking it
      state.processing[id].status = 'rejected';
      state.processing[id].error = error;
    },
    cleanupImageProcessing: (state, action: CleanupImageProcessingAction) => {
      const {
        payload: { id },
      } = action;
      delete state.processing[id];
    },
  },
});
